import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LogIn, AlertCircle } from 'lucide-react';
import './Login.css';

const Login = () => {
  const { user, loginWithGoogle, error } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/admin/dashboard');
    }
  }, [user, navigate]);

  const handleLogin = async () => {
    try {
      await loginWithGoogle();
    } catch (err) {
      console.error('Error en login:', err);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card card">
        <div className="login-header">
          <h2>Panel Administrativo</h2>
          <p>Acceso exclusivo para personal autorizado de Gauss Control</p>
        </div>

        {error && (
          <div className="alert alert-error">
            <AlertCircle size={20} />
            <span>{error}</span>
          </div>
        )}

        <button onClick={handleLogin} className="btn btn-primary login-btn">
          <LogIn size={20} />
          Iniciar Sesión con Google
        </button>

        <div className="login-note">
          <p>Solo usuarios con correo @gausscontrol.com pueden acceder</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
